import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';

import Session from 'supertokens-web-js/recipe/session';

@Injectable()
export class SessionRefreshInterceptor implements HttpInterceptor {
  private refreshInProgress = false;
  private refreshPromise: Promise<boolean> | null = null;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        // Only handle 401/403 errors
        if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
          return this.handleAuthError(req, next);
        }

        return throwError(() => error);
      })
    );
  }

  private handleAuthError(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.refreshInProgress) {
      this.refreshInProgress = true;
      this.refreshPromise = Session.attemptRefreshingSession();
    }

    return from(this.refreshPromise!).pipe(
      switchMap((refreshSuccess) => {
        if (refreshSuccess) {
          return next.handle(req); // Retry original request
        } else {
          // Optionally handle refresh failure (e.g., logout)
          return throwError(() => new Error('Session refresh failed'));
        }
      }),
      catchError((refreshError) => {
        return throwError(() => refreshError);
      }),
      finalize(() => {
        this.refreshInProgress = false;
        this.refreshPromise = null;
      })
    );
  }
}
